import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "m1 9.48c0-3.50889 2.65774-7.48 6.88889-7.48 1.82704 0 3.17721.7105 4.11111 1.51082.9339-.80032 2.2841-1.51082 4.1111-1.51082 4.2312 0 6.8889 3.97111 6.8889 7.48 0 1.8454-.7146 3.5497-1.707 5.0291-.9932 1.4806-2.3006 2.7908-3.5819 3.8707-1.285 1.0831-2.5714 1.9574-3.5475 2.5613-.4887.3024-.904.5396-1.2078.7036-.1511.0816-.2796.1477-.3787.1957-.0482.0233-.0984.0467-.1452.0664-.0221.0093-.056.0231-.0951.0363-.0191.0065-.0514.017-.0912.0268-.0254.0063-.1219.0301-.2456.0301s-.2195-.0237-.2449-.0299c-.0398-.0099-.0728-.0205-.0919-.027-.0391-.0132-.073-.027-.0951-.0363-.0468-.0197-.097-.0431-.1452-.0664-.0991-.048-.2276-.1141-.3787-.1957-.3038-.164-.7191-.4012-1.20783-.7036-.9761-.6039-2.26242-1.4782-3.54748-2.5613-1.28131-1.0799-2.58867-2.3901-3.58186-3.8707-.99239-1.4794-1.70703-3.1837-1.70703-5.0291z",
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }